import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import "core-js/modules/es.array.sort.js";
import { runInAction } from "mobx";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import ChartView from "../../../Charts/ChartView";
import ChartableMixin, { axesMatch } from "../../../ModelMixins/ChartableMixin";
import Checkbox from "../../../Styled/Checkbox/Checkbox";
import { Li, Ul } from "../../../Styled/List";
import { TextSpan } from "../../../Styled/Text";
import { jsx as _jsx } from "react/jsx-runtime";
export const ChartItem = observer(_ref => {
  let {
    chartItem
  } = _ref;
  const {
    t
  } = useTranslation();
  const lineColor = chartItem.isSelectedInWorkbench ? chartItem.getColor() : "#fff";
  const toggleActive = () => {
    const catalogItem = chartItem.item;
    runInAction(() => {
      const shouldSelect = !chartItem.isSelectedInWorkbench;
      chartItem.updateIsSelectedInWorkbench(shouldSelect);
      if (shouldSelect) {
        unselectChartItemsWithXAxisNotMatching(catalogItem.terria.workbench.items, chartItem.xAxis);
      }
    });
  };
  return /*#__PURE__*/_jsx(_StyledCheckbox, {
    id: "depthTestAgainstTerrain",
    isChecked: chartItem.isSelectedInWorkbench,
    title: t("chart.showItemInChart", {
      value: chartItem.name
    }),
    onChange: toggleActive,
    $_css: lineColor,
    children: /*#__PURE__*/_jsx(TextSpan, {
      children: chartItem.name
    })
  });
});
const ChartItemSelector = observer(_ref2 => {
  let {
    item
  } = _ref2;
  const theme = useTheme();
  const chartView = new ChartView(item.terria);
  // We don't need to show selectors for moment datasets. They are part of
  // discretelytimevarying items and have a separate chart button to enable/disable.
  const chartItems = chartView.chartItems.filter(c => c.item === item).filter(c => c.type !== "momentPoints" && c.type !== "momentLines").sort((a, b) => a.name >= b.name ? 1 : -1);
  if (chartItems && chartItems.length === 0) return null;
  return /*#__PURE__*/_jsx(_StyledUl, {
    fullWidth: true,
    spaced: true,
    padded: true,
    column: true,
    rounded: true,
    backgroundColor: theme === null || theme === void 0 ? void 0 : theme.overlay,
    $_css2: theme.spacing,
    children: chartItems.map(chartItem => /*#__PURE__*/_jsx(Li, {
      children: /*#__PURE__*/_jsx(ChartItem, {
        chartItem: chartItem
      })
    }, "li-".concat(chartItem.key)))
  });
});
function unselectChartItemsWithXAxisNotMatching(items, requiredAxis) {
  items.forEach(item => {
    if (ChartableMixin.isMixedInto(item)) {
      item.chartItems.forEach(chartItem => {
        if (!axesMatch(chartItem.xAxis, requiredAxis)) {
          chartItem.updateIsSelectedInWorkbench(false);
        }
      });
    }
  });
}
export default ChartItemSelector;
var _StyledCheckbox = _styled(Checkbox)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n          color: ", ";\n        "])), p => p.$_css);
var _StyledUl = _styled2(Ul).withConfig({
  displayName: "ChartItemSelector___StyledUl",
  componentId: "sc-15zu36l-0"
})(["padding-left:", "px;margin:10px 5px;"], p => p.$_css2);